import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AbcIcon(props: IconProps) {
    return <Icon {...props} iconKey={"abc"}/>
}
